import React from 'react'
import PropTypes from 'prop-types'
import * as S from './LogoHeader.styled'
import Link from 'next/link'
const LogoHeader = (props) => {
    return (
        <Link href="/" passHref legacyBehavior>
            <S.Container>
                <S.LogoImg src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/images/logo-zdorov.svg`} />
            </S.Container>
        </Link>
    )
}

export default LogoHeader
